const roles = {
	warehouseAccountOwner: 'Warehouse Account Owner',
	warehouseAdministrator: 'Warehouse Administrator',
	warehouseUser: 'Warehouse User',
	anonymous: 'Anonymous',
	users: 'Users',
	general: 'General',
	superAdministrators: 'SuperAdministrators',
	sellerAccountOwner: 'Seller Account Owner',
	administrator: 'Administrators',
	accountOwner: 'AccountOwner',
	scanshipSuperAdministrator: 'ScanshipSuperAdministrator',
	smartshipWarehouseAdministrator: 'SmartshipWarehouseAdministrator'
};

const sellerRoles = {
	sellerAccountOwner: 'Seller Account Owner',
	administrator: 'Administrators',
};

const warehouseRoles = {
	warehouseAccountOwner: 'Warehouse Account Owner',
	warehouseAdministrator: 'Warehouse Administrator',
	warehouseUser: 'Warehouse User',
};

const superAdminRoles = {
	scanshipSuperAdministrator: 'ScanshipSuperAdministrator',
	smartshipWarehouseAdministrator: 'SmartshipWarehouseAdministrator'
};

export { roles, sellerRoles, warehouseRoles, superAdminRoles };
